import Vue from 'vue';
import Main from './PreSource.vue';

// 用 Vue.extend 创建组件的模板（构造函数）
let mainConstructor = Vue.extend(Main);

const PreSource = function(url,type){
    let options = {
        url,
        type
    }
    // 实例化组件
    let instance = new mainConstructor({ data: options });
    // 挂载到相应的元素上
    //instance.$mount('#app');
    document.body.appendChild(instance.$mount().$el);
}

export default PreSource;

/*
挂载的位置说明：
1、$mount("#app")
    一般来说我们常见的是把组件挂载到 #app 下面，<router-view /> 也包含在 #app 中
2、document.body.appendChild(instance.$mount().$el);
    如果这种 Message提示是放在 body 下面的，也就是说它不受 #app 和 <router-view /> 的管控，所以当我们切换页面（路由）的时候，这个 Message 组件是不会跟着立马消失的
*/
